import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Container,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Typography,
  AppBar,
  Toolbar,
  Button,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import Footer from '../pages/Footer';
import logo from '../logo.png';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(18,82,166)',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

const UserVerification = () => {
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`https://exam.ethernet.edu.et/api/verify/${userId}`)
      .then((res) => {
        setUserData(res.data.data);
      })
      .catch(() => {
        setError('User not found or an error occurred.');
      });
  }, [userId]);

  if (!userData && !error) {
    return (
      <Container
        component="main"
        sx={{ maxWidth: 'sm', mt: 4, textAlign: 'center' }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container component="main" sx={{ maxWidth: 'sm', mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>

        <Container
          component="main"
          sx={{
            mt: 6,
            mb: 6,
            backgroundColor: '#ffffff',
            borderRadius: 3,
            boxShadow: 3,
            p: 4,
          }}
        >
          <Paper elevation={3} sx={{ borderRadius: 2, p: 3, textAlign: 'center' }}>
            <Typography
              component="h1"
              variant="h5"
              sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}
            >
              Verified
              <Box
                component="img"
                src="https://ngat.ethernet.edu.et/images/verified.png"
                alt="Verified"
                sx={{ width: 40, height: 40, ml: 1 }}
              />
            </Typography>

            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Box
                component="img"
                src={
                  userData.profile_picture
                    ? userData.profile_picture
                    : 'https://exam.ethernet.edu.et/default-avatar.png'
                }
                alt="Profile"
                sx={{
                  width: 140,
                  height: 140,
                  borderRadius: '50%',
                  border: '3px solid rgb(18,82,166)',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  mb: 2,
                }}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Table sx={{ maxWidth: 400 }}>
                <TableBody>
                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      User Name:
                    </TableCell>
                    <TableCell align="left">{userData.username}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      First Name:
                    </TableCell>
                    <TableCell align="left">{userData.firstname}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Father Name:
                    </TableCell>
                    <TableCell align="left">{userData.lastname}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      G. Father Name:
                    </TableCell>
                    <TableCell align="left">{userData.grand_father_name}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Exam Topic:
                    </TableCell>
                    <TableCell align="left">{userData.department || 'N/A'}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Gender:
                    </TableCell>
                    <TableCell align="left">{userData.gender}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                      Exam Center:
                    </TableCell>
                    <TableCell align="left">{userData.exam_center}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Container>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default UserVerification; 